import { Header } from './Header.jsx';

export const Layout = ({ children }) => (
  <div class="flex min-h-screen flex-col bg-bg-base text-text-body">
    <Header />
    <main class="mx-auto w-full max-w-7xl flex-1 px-6 py-8">{children}</main>
  </div>
);
